var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 8.875h-4.5a.376.376 0 0 1-.375-.375v-6c0-.206.169-.375.375-.375h3.284l1.591 1.592V8.5a.376.376 0 0 1-.375.375M6.25 10h4.5c.827 0 1.5-.672 1.5-1.5V3.717c0-.298-.12-.584-.33-.795l-1.59-1.591A1.13 1.13 0 0 0 9.537 1H6.25c-.827 0-1.5.672-1.5 1.5v6c0 .827.673 1.5 1.5 1.5m-3-6c-.827 0-1.5.673-1.5 1.5v6c0 .828.673 1.5 1.5 1.5h4.5c.827 0 1.5-.672 1.5-1.5v-.75H8.125v.75a.376.376 0 0 1-.375.375h-4.5a.376.376 0 0 1-.375-.375v-6c0-.206.169-.375.375-.375H4V4z"
  })));
};
export default SvgCopy;